export class Tag {
  id = -1;
  taggable_type = "";
  color = "";
  color_label = "";
  description = "";
  label = "";
}
